import { render, staticRenderFns } from "./SaveCompanyData.vue?vue&type=template&id=e4c4565c&scoped=true&"
import script from "./SaveCompanyData.vue?vue&type=script&lang=js&"
export * from "./SaveCompanyData.vue?vue&type=script&lang=js&"
import style0 from "./SaveCompanyData.vue?vue&type=style&index=0&id=e4c4565c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c4565c",
  null
  
)

export default component.exports